import { render } from "./ContentItemContainer.vue?vue&type=template&id=38cac9f6&scoped=true"
import script from "./ContentItemContainer.vue?vue&type=script&lang=js"
export * from "./ContentItemContainer.vue?vue&type=script&lang=js"

import "./ContentItemContainer.vue?vue&type=style&index=0&id=38cac9f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cac9f6"]])

export default __exports__